<h2 mat-dialog-title>Luggage Amount Editor</h2>
<mat-dialog-content class="dialog-content-style">
    <app-grid-list [data]="gridData" [isEditable]="isEditable" [isShortVersionNeeded]="true"></app-grid-list>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="cancel()">{{button1}}</button>
  <span class="spacer"></span>
  <button *ngIf="!isEditable" mat-button (click)="save()" [disabled]="false" cdkFocusInitial>{{button2}}</button>
</mat-dialog-actions>